import AtendenteNovo from './AtendenteNovo';

export default AtendenteNovo;